import React from "react";

export default function StatusBadge({ status }) {
  const color =
    status === "Completed"
      ? "#4caf50"
      : status === "In Progress"
        ? "#ff9800"
        : "#9e9e9e";
  return (
    <span
      style={{
        background: color,
        color: "white",
        padding: "4px 8px",
        borderRadius: 12,
        fontSize: 12,
      }}
    >
      {status}
    </span>
  );
}
